export const HEALTHCARE_LICENSE_TYPES = [
  'Medical Indemnity',
  'IMC Registration',
  'NMBI Registration',
  'Children First Certificate',
  'Garda Vetting',
  'Eligibility to Work',
] as const;

export type HealthcareLicenseType = (typeof HEALTHCARE_LICENSE_TYPES)[number];

export function daysUntilExpiry(expiryDate: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expiry = new Date(expiryDate);
  expiry.setHours(0, 0, 0, 0);
  return Math.round((expiry.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export function getLicenseExpiryStatus(expiryDate: string): {
  label: string;
  tone: 'valid' | 'warning' | 'urgent' | 'expired';
} {
  const days = daysUntilExpiry(expiryDate);
  if (days < 0) return { label: 'Expired', tone: 'expired' };
  if (days === 0) return { label: 'Expires today', tone: 'expired' };
  if (days <= 30) return { label: `${days} days left`, tone: 'urgent' };
  if (days <= 90) return { label: `${days} days left`, tone: 'warning' };
  return { label: 'Valid', tone: 'valid' };
}

export const LICENSE_STATUS_STYLES: Record<
  ReturnType<typeof getLicenseExpiryStatus>['tone'],
  { badge: string; border: string; bg: string }
> = {
  valid: { badge: 'bg-green-100 text-green-800', border: 'border-green-200', bg: 'bg-green-50' },
  warning: { badge: 'bg-amber-100 text-amber-800', border: 'border-amber-200', bg: 'bg-amber-50' },
  urgent: { badge: 'bg-orange-100 text-orange-800', border: 'border-orange-200', bg: 'bg-orange-50' },
  expired: { badge: 'bg-red-100 text-red-800', border: 'border-red-200', bg: 'bg-red-50' },
};
